import React from "react";
import { Search, FileText, Share2, FileCheck } from "lucide-react";
import Seo from "@/components/Seo";
import ServiceHero from "@/components/marketing/service/ServiceHero";
import ReachVisualization from "@/components/marketing/service/newswire/ReachVisualization";
import NewswireCatalogue from "@/components/marketing/service/newswire/NewswireCatalogue";
import NewswireWhyUs from "@/components/marketing/service/newswire/NewswireWhyUs";
import HowItWorksLedger from "@/components/marketing/service/HowItWorksLedger";
import ServiceFAQ from "@/components/marketing/service/ServiceFAQ";
import CTASection from "@/components/marketing/CTASection";

const STEPS = [
  { icon: Search, title: "Choose your newswires", desc: "Pick one wire or several, by region or sector." },
  { icon: FileText, title: "Send us your release", desc: "Submit your announcement and any assets." },
  { icon: Share2, title: "We syndicate it", desc: "Your release goes out across the selected networks, same-day submission." },
  { icon: FileCheck, title: "You get the report", desc: "A full pickup report with live published links." },
];

const FAQS = [
  { q: "What is newswire distribution?", a: "Newswire distribution syndicates your press release across a network of media outlets and news sites, giving your announcement broad reach quickly." },
  { q: "How is this different from journalist outreach?", a: "Newswire syndicates your release broadly across networks; journalist outreach pitches your story to individual journalists for earned coverage." },
  { q: "Are the pickups guaranteed?", a: "Each newswire lists its named key site pickups, confirmed in advance. If a named pickup is not published and indexed, it is refunded under our refund policy. Total pickups can be higher." },
  { q: "Can I buy more than one newswire?", a: "Yes, buy a single wire or combine several by region or sector." },
  { q: "Do you offer translations?", a: "Some newswires include translation options, shown on each." },
  { q: "How fast does it go out?", a: "Same-day submission to the selected networks." },
];

export default function NewswireDistribution() {
  const scrollToCatalogue = () =>
    document.getElementById("catalogue")?.scrollIntoView({ behavior: "smooth" });

  return (
    <div className="bg-canvas">
      <Seo title="Newswire Distribution | Digital24" />
      <ServiceHero
        eyebrow="NEWSWIRE DISTRIBUTION"
        title="Your announcement, everywhere at once."
        subtitle="Syndicate your release across 23 newswire networks, 3,900+ outlets, and Google News. Broad, fast, defined reach."
        primaryCTA={{ label: "Browse Newswires", onClick: scrollToCatalogue }}
        secondaryCTA={{ label: "Talk to Our Team", to: "/contact" }}
      />
      <div id="catalogue">
        <NewswireCatalogue />
      </div>
      <ReachVisualization />
      <NewswireWhyUs />
      <HowItWorksLedger
        steps={STEPS}
        tag="HOW IT WORKS"
        title="How newswire distribution works"
      />

      <ServiceFAQ
        faqs={FAQS}
        tag="FAQ"
        title="Frequently Asked Questions"
      />
      <CTASection
        eyebrow="GET STARTED"
        headline="Ready to go everywhere at once?"
        subtitle="Pick your newswires by region or sector and syndicate your release today."
      />
    </div>
  );
}